module.exports = __webpack_public_path__ + "static/media/icon_bus_stop_gray.cd79e11c.png";